import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation, Trans } from 'react-i18next';
import { Box, Button, Modal } from '@material-ui/core';
import GridContainer from 'components/Grid/GridContainer';

export default function CardErrorModal(props) {

  const { t } = useTranslation();

  const useStyles = makeStyles({
    myDiscountCard: {
      backgroundColor: "#F2F4F7",
      flexGrow: 1,
      minWidth: "269px",
      display: "flex",
      flexDirection: "column",
      alignContent: "space-around",
      justifyContent: "space-between"
    }
  });

  const classes = useStyles();

  const carderrormodalBody = (
    //width={{ xs: "80%", md: "40%" }}
    <Box bgcolor="white" borderRadius={16} p={4}
    style={{maxHeight: '80%', overflow: 'auto'}}>
      <GridContainer justify="center" className="paddingBottom32" style={{paddingTop: "16px", paddingLeft: "32px", paddingRight: "32px"}}>
        <span className='regular-b400'>{t("CardErrorModalMessage")}</span>
      </GridContainer>
      <GridContainer justify="center">
        <Button className="regular-b300 cl-secondary-100 myIeseButton" variant="text" onClick={props.close}>
          {t("SaveModalCloseBtn")}
        </Button>
      </GridContainer>
    </Box>
  );
  return (
    <Modal
      open={props.show}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
      onClose={props.close}
    >
      {carderrormodalBody}
    </Modal>
  );
}